"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAPI = void 0;
const fetcher_1 = require("../../core/fetcher");
class BaseAPI extends fetcher_1.Fetcher {
    static API_URL_V3 = 'https://api.themoviedb.org/3';
    apiKey;
    constructor({ url, apiKey, debug = false }) {
        const baseURL = !url ? BaseAPI.API_URL_V3 : url;
        super(baseURL, debug);
        this.apiKey = apiKey;
    }
    getPath(path, queryString) {
        const params = new URLSearchParams({
            ...queryString,
            api_key: this.apiKey,
        });
        return `${path}?${params.toString()}`;
    }
}
exports.BaseAPI = BaseAPI;
